import React, { useMemo } from "react"
import DataTable from "react-data-table-component"
import { customStyles } from "../Common/DataTableStyles"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../../components/ui/dropdown-menu"
import { Button } from "../../../components/ui/button"
import { MoreVertical, Eye, Shield, Loader2 } from "lucide-react"

export const TenantUserTableList = ({
    users,
    isLoading,
    getUserTypeBadge,
    handleViewTenantUser,
    handleAssignRoleAction,
}) => {
    const columns = useMemo(() => [
        {
            name: "User",
            selector: (row) => row.fullName,
            sortable: true,
            cell: (row) => (
                <div className="font-medium text-white py-2">{row.fullName}</div>
            ),
            grow: 2,
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            cell: (row) => (
                <div className="text-sm text-gray-400 py-2">{row.email}</div>
            ),
            grow: 2,
        },
        {
            name: "Role",
            cell: (row) => getUserTypeBadge(row.roleId),
            sortable: true,
            selector: (row) => row.roleId,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex justify-end w-full">
                    <DropdownMenu modal={false}>
                        <DropdownMenuTrigger asChild>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-gray-400 hover:text-white">
                                <MoreVertical className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="bg-black border-gray-800 text-white">
                            <DropdownMenuItem className="hover:bg-gray-800 focus:bg-gray-800" onClick={() => handleViewTenantUser(row)}>
                                <Eye className="h-4 w-4 mr-2" /> View Details
                            </DropdownMenuItem>
                            <DropdownMenuItem className="hover:bg-gray-800 focus:bg-gray-800" onClick={() => handleAssignRoleAction(row)}>
                                <Shield className="h-4 w-4 mr-2" /> Assign Role
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            right: true,
        },
    ], [getUserTypeBadge, handleViewTenantUser, handleAssignRoleAction]);

    return (
        <div className="bg-black rounded-lg shadow overflow-hidden border border-gray-800">
            <DataTable
                columns={columns}
                data={users}
                keyField="id"
                pagination
                progressPending={isLoading}
                progressComponent={
                    <div className="flex items-center justify-center p-10">
                        <Loader2 className="animate-spin h-8 w-8 text-white" />
                    </div>
                }
                noDataComponent={
                    <div className="text-center py-10 text-gray-400">
                        No active users found.
                    </div>
                }
                customStyles={customStyles}
                highlightOnHover
                pointerOnHover
                responsive
            />
        </div>
    )
}
